import { render, staticRenderFns } from "./TypeSelectChoose.vue?vue&type=template&id=3ca6497c&scoped=true&"
import script from "./TypeSelectChoose.vue?vue&type=script&lang=js&"
export * from "./TypeSelectChoose.vue?vue&type=script&lang=js&"
import style0 from "./TypeSelectChoose.vue?vue&type=style&index=0&id=3ca6497c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca6497c",
  null
  
)

export default component.exports